import { LicenseTypeNature } from '../types';

import { SEPARATE_EPHYTO } from '../config';
import { lpcoAbbreviation } from './index';

export const routesByNature = {
  [LicenseTypeNature.LPCO]: lpcoAbbreviation.toLowerCase(),
  [LicenseTypeNature.EPHYTO]: 'ephyto',
};

const defaultRoutes = [
  {
    nature: routesByNature[LicenseTypeNature.LPCO],
    name: lpcoAbbreviation,
  },
];

const separateRoutes = [
  ...defaultRoutes,
  {
    nature: routesByNature[LicenseTypeNature.EPHYTO],
    name: 'EPHYTO',
  },
];

const routes = SEPARATE_EPHYTO ? separateRoutes : defaultRoutes;

export default routes;
